import { RouterAccountMe } from './AccountMe.route.paths';
export default RouterAccountMe;
